import { useState, useEffect } from 'react';
import { useActions } from 'common/hooks/useActions';
import { Switch } from 'antd';
import ImageUploader from 'components/form/imageUploader';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import { useParams } from 'react-router';
import DropDown from 'components/form/dropDown';
import TextIput from 'components/form/textInput';
import { menuCategoryArray } from 'common/enums';
import Customization from './lib/customization';

import * as S from './styles';

export default function CafeteriaMenuManagementCreate() {
  const [isActive, setIsActive] = useState(false);
  const [image, setImage] = useState<any>();
  const [values, setValues] = useState<any>({
    title: '',
    category: null,
    fileUrl: '',
    image: '',
    imageName: '',
    translations: [
      {
        language: 'en',
        translate: ''
      },
      {
        language: 'ar',
        translate: ''
      }
    ]
  });

  const params = useParams();

  const { menuItem }: any = useTypedSelector((state) => state.Cafeteria);

  const { MenuManagementDetailRequestAction } = useActions();

  const renderCategoryName = (cat: string) => {
    let newText: string = '';
    // eslint-disable-next-line array-callback-return
    menuCategoryArray.map((item: any) => {
      if (item.id === cat) newText = item.title;
    });
    return newText;
  };

  useEffect(() => {
    if (params?.id) MenuManagementDetailRequestAction(params?.id);
  }, [params?.id]);

  useEffect(() => {
    if (params?.id && menuItem) {
      setValues({
        ...values,
        title: menuItem?.data?.list?.title,
        category: menuItem?.data?.list?.category,
        translations: [
          {
            language: 'en',
            translate: menuItem?.data?.list?.menuTranslations?.find((t: any) => t.language === 'en')?.translate || ''
          },
          {
            language: 'ar',
            translate: menuItem?.data?.list?.menuTranslations?.find((t: any) => t.language === 'ar')?.translate || ''
          }
        ]
      });
      setIsActive(menuItem?.data?.list?.status);
      setImage(menuItem?.data?.list?.image);
      return;
    }
    setImage(null);
  }, [menuItem, params?.id]);

  return (
    <S.Content>
      <S.Head>
        <S.Title>Menu Details</S.Title>

        <S.SwitchContainer>
          <S.SwitchTitle style={{ color: isActive ? '#1DBAAF' : '#FF6464' }}>
            {isActive ? 'Active' : 'InActive'}
          </S.SwitchTitle>
          <Switch
            checked={isActive}
            size="default"
            onChange={() => setIsActive(!isActive)}
            style={{
              backgroundColor: isActive ? '#1DBAAF' : '#FF6464'
            }}
          />
        </S.SwitchContainer>
      </S.Head>

      <S.Body>
        <form style={{ width: '100%', marginTop: '0.5rem' }}>
          <S.FormHeaderContainer>
            <S.FormHeader>
              <DropDown
                label="Category"
                list={menuCategoryArray}
                onChange={(e) => setValues({ ...values, category: e?.id as any })}
                key={values.category}
                placeholder="Category"
                defaultValue={{
                  id: values.category,
                  title: renderCategoryName(values.category)
                }}
                disabled={!!params?.id}
              />

              <TextIput
                type="text"
                name="en-title"
                placeholder="English Title..."
                value={values?.translations?.find((t: any) => t.language === 'en')?.translate || ''}
                onChange={(e) => {
                  setValues({
                    ...values,
                    translations: values?.translations?.map((t: any) =>
                      t.language === 'en' ? { ...t, translate: e.target.value } : t
                    )
                  });
                }}
                label="English Title"
              />
            </S.FormHeader>

            <S.FormHeader>
              <S.Uploader>
                <ImageUploader setImage={setImage} defaultImage={image} values={values} setValues={setValues} />
              </S.Uploader>

              <TextIput
                type="text"
                name="ar-title"
                placeholder="العنوان باللغة العربية ..."
                value={values?.translations?.find((t: any) => t.language === 'ar')?.translate || ''}
                onChange={(e) => {
                  setValues({
                    ...values,
                    translations: values?.translations?.map((t: any) =>
                      t.language === 'ar' ? { ...t, translate: e.target.value } : t
                    )
                  });
                }}
                label="Arabic Title"
              />
            </S.FormHeader>
          </S.FormHeaderContainer>
        </form>

        <Customization
          selectedOptions={menuItem?.data?.list?.selectedOptions}
          btnTitle={values?.translations?.find((t: any) => t.language === 'en')?.translate || ''}
          title={values.translations}
          category={values.category}
          image={image}
          activeStatus={isActive}
          values={values}
        />
      </S.Body>
    </S.Content>
  );
}
